const autocompleteFromCreateUser = {
  site: 'Sites',
  companies: 'Third party company'
};

export default autocompleteFromCreateUser;
